// Batch 7 — validation constants for mastery-workflow phase criteria.
//
// PROVISIONAL — pending clinical confirmation. Kept as single named
// constants (not scattered numeric literals) so the clinical team can
// change either value with a one-line edit.

/**
 * Minimum accuracy % for any non-starting phase. Starting phases
 * (isStarting=true) legitimately allow 0 (a baseline phase has no
 * accuracy requirement). Any other phase below this floor is hard-
 * blocked at save with an inline field error.
 *
 * Compare as: `value < MIN_ACCURACY_NON_STARTING` → hard block.
 */
export const MIN_ACCURACY_NON_STARTING = 50;

/**
 * Amber-warning band. Non-starting phases with an accuracy value at or
 * above MIN but below this threshold render an amber warning under the
 * field; save is still permitted.
 *
 * Compare as: `value < AMBER_WARN_BELOW` (only if value >= MIN and
 * !isStarting) → amber warning.
 */
export const AMBER_WARN_BELOW = 80;
